var http = require('./via-axios').default

/**

 * HTTP 请求接口定义
 * @param  {String} url     请求路径（基于 baseUrl, 注意要以'/'开头）
 * @param  {Object} data    请求体数据（只限POST请求）
 * @param  {Object} params  请求参数（请求时附在url之后）
 * @return {Promise}

 */

export default http



// WEBPACK FOOTER //
// ./src/assets/js/http/index.js